import axios from 'axios';
import { CB_URL, CB_TOKEN } from '../../config';

const instanceCB = axios.create({
  baseURL: CB_URL, 
});

instanceCB.interceptors.request.use(
  config => {
    const token = CB_TOKEN
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);


instanceCB.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response && error.response.status === 401) {
      // window.location.href = '/login';  
    }
    return Promise.reject(error);
  }
);

export default instanceCB;
